import Funds from '@/services/funds'
import http from '@/services/http'

const find = async (context, id) => {
  return new Promise((resolve, reject) => {
    Funds.get(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const findCommit = async ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    Funds.get(id).then((response) => {
      commit('SET_FUND', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const save = async ({ commit }, payload) => {
  return new Promise(async (resolve, reject) => {
    const { verb, dataFund } = payload
    const method = verb === 'put' ? 'update' : 'save'

    Funds[method](dataFund).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      commit('SET_ERRORS', error.response.data)
      reject(error)
    })
  })
}

const fetch = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Funds.fetch().then((response) => {
      commit('SET_LIST', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fundsByPayer = async ({commit}, id) => {
  const response = await http.get(`/funds/by_payer_id/${id}`)
  if (response != null) {
    commit('SET_LIST', response.data)
  }
}

const fundsAvailableToAssignorByPayerCnpj = async ({commit}, obj) => {
  const response = await http.get(`/assignors/${obj.assignorId}/funds_available/by_payer_cnpj?payer_cnpj=${obj.payerCnpj}`)
  if (response != null) {
    const funds = response.data.map((fund) => ({id: fund.id, text: fund.label}))
    commit('SET_LIST', funds)
  }
}

const resetState = ({ commit }) => {
  commit('RESET_STATE')
}

const resetStateErrors = ({ commit }) => {
  commit('RESET_ERRORS')
}

const updateValues = ({ commit }, payload) => {
  commit('UPDATE_VALUES', payload)
}

const resetListFund = ({ commit }) => {
  commit('RESET_LIST')
}

export default {
  find,
  findCommit,
  save,
  resetState,
  resetStateErrors,
  updateValues,
  fetch,
  resetListFund,
  fundsByPayer,
  fundsAvailableToAssignorByPayerCnpj
}



// WEBPACK FOOTER //
// ./src/features/funds/store/actions.js